import { ClientMappingField, ClientMappingValue, defaultClientMappingField } from "@avenueops/shared-types";

/**
 * Get the append update function for a list of mapping fields or values
 */
export function appendGetter<T extends ClientMappingField | ClientMappingValue>(update: (_: T[]) => void, units: T[] | undefined, defaultUnit: T) {
  return () => {
    const newUnits = units ? [...units] : [];
    newUnits.push(defaultUnit);
    update(newUnits);
  };
}

/**
 * Get the remove update function for a list of mapping fields or values
 */
export function removeGetter<T extends ClientMappingField | ClientMappingValue>(index: number, update: (_: T[]) => void, units: T[]) {
  return () => {
    const newUnits = [...units];
    newUnits.splice(index, 1);
    update(newUnits);
  };
}

/**
 * Get the update function for an item in a list of mapping fields or values
 */
export function updateGetter<T extends ClientMappingField | ClientMappingValue>(index: number, update: (_: T[]) => void, units: T[]) {
  return (unit: T) => {
    const newUnits = [...units];
    newUnits.splice(index, 1, unit);
    update(newUnits);
  };
}
